import { put, putResolve, takeEvery } from 'redux-saga/effects';
import { uuid } from 'uuidv4';
import { UTILITY_NOTIFICATION_INIT } from '../../actions/utility-actions';
import * as actions from '../../actions/utility-actions';
import { UserNotification } from '../../models/utilities/user-notification';
import { Mapper } from '../../utils/mapper';

/**
 * Saga for getting the application service centers for the portal
 */
export function* getNotifications() {

    let notifs : UserNotification[] = [];

    try {

        const rawResponse = yield putResolve(actions.fetch('/notifications', 'GET'));
        const mappedResponse = Mapper.deserializeList(UserNotification, rawResponse);
        if(mappedResponse)
        {
            notifs = mappedResponse;
        }

    }
    catch (err) {
        console.error(err);
    }    

    yield put(actions.resetNotifications(notifs));

}

export function* getNotificationsWatcher() {
    yield takeEvery(UTILITY_NOTIFICATION_INIT, getNotifications);
}
